type Listener = () => void;
let waiting: ServiceWorker | null = null;
let installEvent: any = null;
const updateListeners = new Set<Listener>();
const installListeners = new Set<Listener>();

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("beforeinstallprompt", (e: any) => {
    e.preventDefault();
    installEvent = e;
    installListeners.forEach((l) => l());
  });
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      const track = (sw: ServiceWorker | null) => {
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            waiting = sw;
            updateListeners.forEach((l) => l());
          }
        });
      };
      if (reg.waiting && navigator.serviceWorker.controller) { waiting = reg.waiting; updateListeners.forEach((l) => l()); }
      reg.addEventListener("updatefound", () => track(reg.installing));
      setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);
    } catch { /* SW registration failed; app works without offline shell */ }
  });
  let reloading = false;
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading || !hadController) return;
    reloading = true;
    window.location.reload();
  });
}

export const pwa = {
  hasUpdate: () => !!waiting,
  applyUpdate: () => waiting?.postMessage({ type: "SKIP_WAITING" }),
  onUpdate: (l: Listener) => { updateListeners.add(l); return () => { updateListeners.delete(l); }; },
  canInstall: () => !!installEvent,
  onInstallable: (l: Listener) => { installListeners.add(l); return () => { installListeners.delete(l); }; },
  async promptInstall() {
    if (!installEvent) return false;
    installEvent.prompt();
    const res = await installEvent.userChoice;
    installEvent = null;
    return res?.outcome === "accepted";
  },
  isStandalone: () => window.matchMedia("(display-mode: standalone)").matches || (navigator as any).standalone === true,
  isIOS: () => /iphone|ipad|ipod/i.test(navigator.userAgent),
};
